<!-- 科研机构详情页 -->
<template>
  <div id="institutions-detail" class="box safe-distance-top-header">
    <Header :pageTitle="''" :shareInfo="shareInfo" />
    <AnchorScrollNav
      :tabsTitleList="tabsTitle"
      anchorFlag=".info-cards"
      faBoxId="institutions-detail"
    />
    <div class="title-box">
      <img
        :src="
          orgInfo.coverImg
            ? $global.imgUrl + orgInfo.coverImg
            : require('@/assets/img/mobile-img/jigou-logo.png')
        "
        alt=""
      />
      <span>{{ orgInfo.name }}</span>
    </div>
    <div class="info-box">
      <!-- 简介 -->
      <div ref="introBoxs" class="info-cards intro-box" name="简介">
        <h3 class="card-title">简介</h3>
        <!-- 外文名称 -->
        <div class="msg" v-if="orgInfo.orgBaseType">
          <span class="label">类型：</span>
          <span>{{ orgInfo.orgBaseType | typeFormat }}</span>
        </div>
        <!-- 外文名称 -->
        <div class="msg" v-if="orgInfo.englishName">
          <span class="label">外文名称：</span>
          <span>{{ orgInfo.englishName }}</span>
        </div>
        <!-- 简称 -->
        <div
          class="msg"
          v-if="orgInfo.orgBaseType !== 4 && orgInfo.abbreviation"
        >
          <span class="label">简称：</span>
          <span>{{ orgInfo.abbreviation }}</span>
        </div>
        <!-- 出版单位类型 -->
        <div v-if="orgInfo.orgBaseType === 1">
          <div class="msg" v-if="orgInfo.address">
            <span class="label">地址：</span>
            <span>{{ orgInfo.address }}</span>
          </div>
          <div class="msg" v-if="orgInfo.website">
            <span class="label">官方网址：</span>
            <span>{{ orgInfo.website }}</span>
          </div>
        </div>
        <!-- 行业组织类型 -->
        <div v-if="orgInfo.orgBaseType === 2">
          <div class="msg" v-if="orgInfo.company">
            <span class="label">主管部门：</span>
            <span>{{ orgInfo.company }}</span>
          </div>
          <div class="msg" v-if="orgInfo.achievement">
            <span class="label">主要成就：</span>
            <span>{{ orgInfo.achievement }}</span>
          </div>
          <div class="msg" v-if="orgInfo.registrationUnit">
            <span class="label">登记单位：</span>
            <span>{{ orgInfo.registrationUnit }}</span>
          </div>
          <div class="msg" v-if="orgInfo.website">
            <span class="label">属性：</span>
            <span>{{ orgInfo.website }}</span>
          </div>
          <div class="msg" v-if="orgInfo.address">
            <span class="label">地址：</span>
            <span>{{ orgInfo.address }}</span>
          </div>
        </div>
        <!-- 科研机构类型 -->
        <div v-if="orgInfo.orgBaseType === 3">
          <div class="msg" v-if="orgInfo.company">
            <span class="label">主管部门：</span>
            <span>{{ orgInfo.company }}</span>
          </div>
          <div class="msg" v-if="orgInfo.address">
            <span class="label">科研地址：</span>
            <span>{{ orgInfo.address }}</span>
          </div>
          <div class="msg" v-if="orgInfo.establishTime">
            <span class="label">成立时间：</span>
            <span>{{ orgInfo.establishTime }}</span>
          </div>
        </div>
        <!-- 政府机构类型 -->
        <div v-if="orgInfo.orgBaseType === 4">
          <div class="msg" v-if="orgInfo.type">
            <span class="label">行政级别：</span>
            <span>{{ orgInfo.type }}</span>
          </div>
          <div class="msg" v-if="orgInfo.category">
            <span class="label">性质：</span>
            <span>{{ orgInfo.category }}</span>
          </div>
          <div class="msg" v-if="orgInfo.establishTime">
            <span class="label">成立时间：</span>
            <span>{{ orgInfo.establishTime }}</span>
          </div>
          <div class="msg" v-if="orgInfo.address">
            <span class="label">办公地址：</span>
            <span>{{ orgInfo.address }}</span>
          </div>
        </div>
        <!-- 院校类型 -->
        <div v-if="orgInfo.orgBaseType === 5">
          <div class="msg" v-if="orgInfo.company">
            <span class="label">主管部门：</span>
            <span>{{ orgInfo.company }}</span>
          </div>
          <div class="msg" v-if="orgInfo.establishTime">
            <span class="label">创办时间：</span>
            <span>{{ orgInfo.establishTime }}</span>
          </div>
          <div class="msg" v-if="orgInfo.address">
            <span class="label">地址：</span>
            <span>{{ orgInfo.address }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.founder">
            <span class="label">创办人：</span>
            <span>{{ orgAcademy.founder }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.category">
            <span class="label">办学性质：</span>
            <span>{{ orgAcademy.category }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.schoolType">
            <span class="label">学校类别：</span>
            <span>{{ orgAcademy.schoolType }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.schoolFeature">
            <span class="label">学校特色：</span>
            <span>{{ orgAcademy.schoolFeature }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.affiliatedEnterprise">
            <span class="label">所属企业：</span>
            <span>{{ orgAcademy.affiliatedEnterprise }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.currentLeader">
            <span class="label">现任领导：</span>
            <span>{{ orgAcademy.currentLeader }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.academician">
            <span class="label">专职院士数：</span>
            <span>{{ orgAcademy.academician }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.higherVocationalProfession">
            <span class="label">高职专业：</span>
            <span>{{ orgAcademy.higherVocationalProfession }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.undergraduateMajor">
            <span class="label">本科专业：</span>
            <span>{{ orgAcademy.undergraduateMajor }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.master">
            <span class="label">硕士点：</span>
            <span>{{ orgAcademy.master }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.doctor">
            <span class="label">博士点：</span>
            <span>{{ orgAcademy.doctor }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.postdoctor">
            <span class="label">博士后：</span>
            <span>{{ orgAcademy.postdoctor }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.coreSubject">
            <span class="label">国家重点学科：</span>
            <span>{{ orgAcademy.coreSubject }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.faculty">
            <span class="label">院系设置：</span>
            <span>{{ orgAcademy.faculty }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.motto">
            <span class="label">校训：</span>
            <span>{{ orgAcademy.motto }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.schoolSong">
            <span class="label">校歌：</span>
            <span>{{ orgAcademy.schoolSong }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.schoolDay">
            <span class="label">校庆日：</span>
            <span>{{ orgAcademy.schoolDay }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.collegeMotto">
            <span class="label">院训：</span>
            <span>{{ orgAcademy.collegeMotto }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.courtyardSong">
            <span class="label">院歌：</span>
            <span>{{ orgAcademy.courtyardSong }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.collegeDay">
            <span class="label">院庆日：</span>
            <span>{{ orgAcademy.collegeDay }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.schoolCode">
            <span class="label">院校代码：</span>
            <span>{{ orgAcademy.schoolCode }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.majorAwards">
            <span class="label">主要奖项：</span>
            <span>{{ orgAcademy.majorAwards }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.famousAlumni">
            <span class="label">知名校友：</span>
            <span>{{ orgAcademy.famousAlumni }}</span>
          </div>
          <div class="msg" v-if="orgAcademy.famousTeachers">
            <span class="label">知名教师：</span>
            <span>{{ orgAcademy.famousTeachers }}</span>
          </div>
        </div>
        <!-- 其他类型 -->
        <div v-if="orgInfo.orgBaseType === 6"></div>
        <!-- 机构概述 -->
        <div class="msg" v-if="orgInfo.outline">
          <span class="label">简介：</span>
          <span>{{ orgInfo.outline }}</span>
        </div>
        <div ref="introBtn" class="unfold" @click="toUnfold">
          <span>展开 </span>
          <van-icon name="arrow-down" size="10" color="#999" />
        </div>
      </div>
      <!-- 学者 -->
      <div class="info-cards" name="学者" v-if="scholarsList.length > 0">
        <h3 class="card-title">学者</h3>
        <div class="card-more" @click="toMore(0)">
          <span>更多</span>
          <van-icon name="arrow" size="6px" color="#999" />
        </div>
        <div class="list-box">
          <BjItem
            class="bj-list-item"
            v-for="item in scholarsList"
            :key="item.id"
            :headerPhoto="item.headPhoto"
            :name="item.name"
            :unit="item.unit"
            :research="item.researchDirection"
            @click.native="jumpbaijia(item.id)"
          />
        </div>
      </div>
      <!-- 期刊 -->
      <div class="info-cards" name="期刊" v-if="journalList.length > 0">
        <h3 class="card-title">期刊</h3>
        <div class="card-more" @click="toMore(1)">
          <span>更多</span>
          <van-icon name="arrow" size="6px" color="#999" />
        </div>
        <div class="list-box">
          <BkItem
            class="bk-list-item"
            v-for="item in journalList.slice(0, 6)"
            :key="item.id"
            :cover="item.coverImg"
            :name="item.name"
            @click.native="jumpbaike(item.id)"
          />
        </div>
      </div>
      <!-- 会议 -->
      <div class="info-cards" name="会议" v-if="meetingList.length > 0">
        <h3 class="card-title">会议</h3>
        <div class="card-more" @click="toMore(2)">
          <span>更多</span>
          <van-icon name="arrow" size="6px" color="#999" />
        </div>
        <div class="list-box">
          <XshyItem
            class="hy-list-item"
            v-for="item in meetingList"
            :key="item.id"
            :title="item.title"
            :cover="item.cover"
            :beginTime="
              item.beginTime.slice(0, 10).replace(RegExp('-', 'g'), '.')
            "
            :address="item.province + '-' + item.city"
            @click.native="jumphy(item.id, item.open)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/detail/components/detailHeader.vue";
import BjItem from "@/views/mobileView/components/listItem/bjItem.vue";
import BkItem from "@/views/mobileView/components/listItem/bkItem.vue";
import XshyItem from "@/views/mobileView/components/listItem/xshyItem.vue";
import AnchorScrollNav from "@/views/mobileView/detail/components/anchorScrollNav.vue";
export default {
  components: {
    Header,
    BjItem,
    BkItem,
    XshyItem,
    AnchorScrollNav,
  },
  filters: {
    typeFormat(type) {
      switch (type) {
        case 1:
          return "出版单位";
        case 2:
          return "行业组织";
        case 3:
          return "科研机构";
        case 4:
          return "政府机构";
        case 5:
          return "院校";
        case 6:
          return "其他";
      }
    },
  },
  data() {
    //这里存放数据
    return {
      tabsTitle: [
        {
          anchorName: "简介",
          active: true,
        },
        {
          anchorName: "学者",
          active: false,
        },
        {
          anchorName: "期刊",
          active: false,
        },
        {
          anchorName: "会议",
          active: false,
        },
      ],
      orgInfo: {},
      orgAcademy: {},
      scholarsList: [],
      journalList: [],
      meetingList: [],
      shareInfo: {},
    };
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo();
  },
  mounted() {
    setTimeout(() => {
      let dom = this.$refs.introBoxs;
      let dom2 = this.$refs.introBtn;
      if (dom.scrollHeight <= 320) dom2.style.display = "none";
    }, 500);
  },
  //方法集合
  methods: {
    // 简介展开
    toUnfold() {
      let dom = this.$refs.introBoxs;
      let dom2 = this.$refs.introBtn;
      dom.style.maxHeight = "100%";
      dom2.style.display = "none";
    },
    vanTabsScroll({ scrollTop, isFixed }) {
      // this.$refs.infoCards.scrollTo()
      // document.querySelector('.van-sticky').style.display = isFixed ? 'block' : 'none'
    },
    // 跳转百科详情页
    jumpbaike(id) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/appusesbaike",
        query: {
          item: 1,
          id,
          out,
        },
      });
    },
    // 跳转百家详情页
    jumpbaijia(id) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/appusesbaijia",
        query: {
          item: 0,
          id,
          out,
        },
      });
    },
    // 跳转会议详情页
    jumphy(id, open, goodsId) {
      let out = this.$route.query.out;
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${id || goodsId}${
            open ? "&open=" + open : ""
          }${out ? "&out=" + out : ""}`,
        "_self"
      );
    },
    // 跳转期刊/学者/会议更多页
    toMore(status) {
      let out = this.$route.query.out;
      switch (status) {
        case 0:
          this.$router.push(
            `/institutionsScholars?orgId=${this.$route.query.orgId}${
              out ? "&out=" + out : ""
            }`
          );
          break;
        case 1:
          this.$router.push(
            `/institutionsJournal?orgId=${this.$route.query.orgId}${
              out ? "&out=" + out : ""
            }`
          );
          break;
        case 2:
          this.$router.push(
            `/institutionsMeeting?orgId=${this.$route.query.orgId}${
              out ? "&out=" + out : ""
            }`
          );
          break;
      }
    },
    // 获取详情
    getInfo() {
      this.$apis.hundredServe
        .nfdetail({
          orgId: this.$route.query.orgId,
        })
        .then((res) => {
          // 名录总体数据
          this.orgInfo = res.orgInfo;
          // 院校类型数据
          this.orgAcademy = res.orgInfo.orgAcademy
            ? res.orgInfo.orgAcademy
            : {};
          this.scholarsList = [...res.orgUser];
          this.journalList = [...res.orgPeriodicalList];
          this.shareInfo = {
            title: this.orgInfo.name,
            artSummary: this.orgInfo.outline,
            cover: this.orgInfo.coverImg,
            articleId: this.$route.query.orgId,
            userType: 3,
          };
          this.getMeeting();
        });
    },
    // 获取会议
    async getMeeting() {
      const res = await this.$apis.recomendServe.getListByOrgId({
        orgId: this.$route.query.orgId,
        pageNo: 1,
        pageSize: 6,
      });
      if (res.resultCode === "200") {
        this.meetingList = [...res.data.list];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  padding-top: 44px;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
  .title-box {
    display: flex;
    align-items: center;
    padding: 15px 0;
    background-color: #fff;
    img {
      margin-left: 26px;
      margin-right: 18px;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      object-fit: cover;
    }
    span {
      font-size: 16px;
      font-weight: 700;
      color: #333333;
      line-height: 24px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .info-box {
    margin-top: 12px;
    padding: 0 11px;
    .info-cards {
      position: relative;
      margin-bottom: 15px;
      padding: 15px 12px;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      .card-title {
        margin-bottom: 20px;
        font-size: 17px;
        font-weight: 700;
        color: #333333;
        line-height: 24px;
      }
      .card-more {
        position: absolute;
        top: 18px;
        right: 13px;
        font-size: 13px;
        color: #999999;
      }
    }
    .intro-box {
      position: relative;
      max-height: 320px;
      height: 100%;
      overflow: hidden;
      .msg {
        display: flex;
        margin-bottom: 15px;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
        span {
          word-break: break-all;
        }
        .label {
          flex-shrink: 0;
          width: 100px;
          margin-right: 20px;
        }
      }
      .unfold {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 5px 0 15px;
        width: 100%;
        background-color: #fff;
        text-align: center;
        font-size: 12px;
        font-weight: 700;
        color: #999999;
        line-height: 21px;
      }
    }
  }
  .list-box {
    .bk-list-item {
      display: inline-block;
      margin-right: 14px;
      margin-bottom: 15px;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
    .hy-list-item {
      margin-bottom: 20px;
      padding-bottom: 5px;
      border-radius: 6px;
      border: 1px solid #e5e5e5;
    }
    .bj-list-item {
      margin-bottom: 25px;
    }
  }
}
</style>
